"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.draftPublishedProperties = exports.DRAFT_PUBLISHED = void 0;
var DRAFT_PUBLISHED = exports.DRAFT_PUBLISHED = {
  name: 'Draft published',
  required: ['type', 'groupId', 'assetId', 'version', 'isEditMode']
};
var draftPublishedProperties = exports.draftPublishedProperties = function draftPublishedProperties(payload) {
  return {
    type: payload.type,
    groupId: payload.groupId,
    assetId: payload.assetId,
    version: payload.version,
    isEditMode: payload.isEditMode
  };
};
//# sourceMappingURL=events.js.map